import * as Config from '../../../config/config';

export const CustomerData = {
    getCustomer: function() {
        if(localStorage.getItem(Config.CUSTOMER_DATA_KEY)) {
            return JSON.parse(localStorage.getItem(Config.CUSTOMER_DATA_KEY));
        }

        return '';
    },

    getToken: function() {
        if(localStorage.getItem(Config.TOKEN_KEY)) {
            return localStorage.getItem(Config.TOKEN_KEY);
        }

        return '';
    },
    clearCartData: function() {
        localStorage.removeItem(Config.CART_ITEMS_KEY);
    },

    clearData: function() {
        localStorage.removeItem(Config.TOKEN_KEY);
        localStorage.removeItem(Config.CUSTOMER_DATA_KEY);
        localStorage.removeItem(Config.CART_ITEMS_KEY);
    },

    getCartitems: function() {
        if(localStorage.getItem(Config.CART_ITEMS_KEY)) {
            return JSON.parse(localStorage.getItem(Config.CART_ITEMS_KEY));
        }

        return [];
    },

    setCartItems: function(items) {
        localStorage.setItem(Config.CART_ITEMS_KEY,JSON.stringify(items));
    }
}